import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router'; 

@Component({
  selector: 'app-lgpd-popup',
  standalone: true,
  imports: [
    NgIf,
    RouterLink 
  ],
  templateUrl: './lgpd-popup.html',
  styleUrls: ['./lgpd-popup.scss']
})
export class LgpdPopupComponent {

  show = false;

  constructor() {
    const accepted = localStorage.getItem('lgpd_accept');
    if (!accepted) this.show = true;
  }

  accept() {
    localStorage.setItem('lgpd_accept', 'true');
    this.show = false;
  }
}
